import React from 'react';
import { NotificationIcon } from '../Icons';

const NotificationPopup = ({ data, onClose, remaining }) => {
    return (
        <div className="notification-overlay" dir='rtl'>
            <div className="notification-card">
                {remaining > 0 && (
                    <span className="queue-badge">+{remaining} إشعارات أخرى</span>
                )}

                <div className="notification-header">
                    <div style={{
                        padding:'0.5rem',
                        background:'rgba(22,50,59,0.2)',
                        borderRadius:"0.5rem"
                    }}>
                    <NotificationIcon/>

                    </div>
                    <h3 style={{
                        fontSize: '1.3rem',
                        color: '#111827',
                        fontWeight: 'bold'
                    }}>{data.title}</h3>
                </div>

                <div className="notification-body">
                    <p>{data.message}</p>
                </div>

                <div className="notification-footer">
                    <button className="btn-close" onClick={onClose}>إغلاق</button>
                    {/* {data.row_id && (
                        <button className="btn-action" onClick={() => window.location.href = `/tasks/${data.row_id}`}>
                            عرض 
                        </button>
                    )} */}
                </div>
            </div>
        </div>
    );
};

export default NotificationPopup;